// extracted by css-extract-rspack-plugin
export default {"error":"ErrorMessage-module__error__yfAda","errorIcon":"ErrorMessage-module__errorIcon__HC5Dj","errorHeader":"ErrorMessage-module__errorHeader__GiAZQ"};